export default __webpack_public_path__ + "static/media/files-icon.d8028c3d.svg";